import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { v4 as uuidv4 } from "uuid";

// Mui
import { Box, Stack, Typography } from "@mui/material";

//Css
import classes from "./Signin.module.css";
// Local
import CustomCard from "../../components/UI/Cards/CustomCard";
import OtpInputs from "../../components/UI/Form/OtpInputs";
import PrimaryButton from "../../components/UI/Buttons/PrimaryButton";
import { authActions } from "../../store/state-slices/auth";
import {
  Text,
  Container,
  Button,
  InputCode,
  Spinner,
  Notifications,
  ActionButton,
  Icon,
} from "@jds/core";
import useInput from "../../hooks/use-input";
import { validatePassword } from "../../util/validation";
import useApiHttp from "../../hooks/use-http";
import FormErrorLabel from "../../components/UI/FormErrorLabel/FormErrorLabel";
import { bytesToGB, getDeviceDetails } from "../../util/helper";

export default function Otp(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { phoneNumber, countryCode, identifier } = location.state;
  const [deviceKey, setDeviceKey] = useState(0);
  const [step, setStep] = useState(0);
  const [userAccounts, setUserAccounts] = useState([]);
  const [userId, setUserId] = useState(null);
  const [requestId, setRequestId] = useState(null);

  const {
    value: otp,
    isValid: isValidOtp,
    hasError: otpError,
    valueChangeHandler: otpChangeHandler,
    inputBlurHandler: otpBlurHandler,
    reset: resetOtp,
  } = useInput(validatePassword);
  const { sendRequest: verifyUserOtp, isLoading: verifyOtpLoading } =
    useApiHttp();
  const { sendRequest: userIdLogin, isLoading: userIdLoginLoading } =
    useApiHttp();
  const { sendRequest: resendOtp, isLoading: resendOTPLoading } = useApiHttp();

  const isValidForm = !isValidOtp;
  const handleSubmit = (e) => {
    // e.preventDefault();
    verifyUserOtp(
      {
        base: "JCAPI",
        isBearer: false,
        url: `account/jioid/verifyotp `,
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          "X-Api-Key": process.env.REACT_APP_APIKEY,
          "X-App-Secret": process.env.REACT_APP_APPSECRET,
          "X-Client-Details": process.env.REACT_APP_CLIENTDETAILS,
          "X-Device-Key": deviceKey,
          "X-Device-Type": "W",
        },
        body: {
          // countryCode: countryCode,
          mobileNumber: "+91" + phoneNumber,
          otp: otp,
          isMnr: "Y",
        },
      },
      null,
      (data) => {
        if (data?.userAccounts?.length == 1) {
          setRequestId(data?.requestId);
          setUserId(data?.userAccounts[0]?.userId);
          handleUserIdLogin(data?.userAccounts[0]?.userId, data?.requestId);
        } else {
          setRequestId(data?.requestId);
          setUserAccounts(data?.userAccounts);
          setStep(1);
        }
      },
      (_, data) => {
        Notifications.toast.error({ id: "verify-otp", title: data?.error });
      },
    );
  };

  const handleUserIdLogin = (userId, requestId) => {
    let deviceDetails = getDeviceDetails();
    userIdLogin(
      {
        base: "JCAPI",
        isBearer: false,
        url: `account/jioid/useridlogin`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": process.env.REACT_APP_APIKEY,
          "X-App-Secret": process.env.REACT_APP_APPSECRET,
          "X-Client-Details": process.env.REACT_APP_CLIENTDETAILS,
        },
        body: {
          userId,
          requestId,
          deviceType: "W",
          mobileNumber: "+91" + phoneNumber,
          deviceInfo: {
            deviceKey,
            model: "browser",
            deviceName: "Web Device",
            platformType: deviceDetails?.platformType || "Chrome",
            platformVersion: deviceDetails?.platformVersion || "",
            type: "browser",
            isWebClient: true,
          },
        },
        credentials: "include",
      },
      null,
      (data) => {
        navigate(
          `/login?jwt=${data?.jcJWT}&dcCode=${data?.dcGroupCode?.toLowerCase()}`,
        );
      },
      (_, data) => {
        Notifications.toast.error({ id: "userid-login", title: data?.error });
        navigate("/");
      },
    );
  };
  const resendOTPHandler = () => {
    resendOtp(
      {
        base: "AUTH",
        isBearer: false,
        url: `user/web-login`,
        method: "POST",
        body: {
          countryCode,
          phoneNumber,
        },
      },
      null,
      (data) => {
        Notifications.toast.success({
          id: "resend-otp",
          title: "OTP resent successfully",
        });
      },
      (err, data) => {
        Notifications.toast.success({ id: "resend-otp", title: data?.message });
      },
    );
  };
  useEffect(() => {
    setDeviceKey(uuidv4());
  }, []);
  return (
    <CustomCard
      sx={{
        padding: "32px",
        maxWidth: "484px",
        minWidth: "484px",
        minHeight: "585px",
        "@media screen and (max-width: 1024px)": {
          minWidth: "unset",
        },
      }}>
      <div>
        {step == 0 && (
          <Container
            direction="column"
            fullWidth
            style={{ justifyContent: "" }}>
            <Container direction="column" gap={16} fullWidth>
              <Text appearance="heading-xs">Verify your mobile number</Text>
              <Container direction="column" gap={0} className="">
                <Text appearance="body-s">Enter the OTP sent to </Text>
                <Container direction="row" gap={5}>
                  <Text appearance="body-s">
                    {`${countryCode}${phoneNumber}`}.
                  </Text>
                  <Link to={"/auth/signin"}>
                    <Text appearance="body-s-link">Change number</Text>
                  </Link>
                </Container>
              </Container>
            </Container>
            <Container
              direction="column"
              fullWidth
              style={{ margin: "48px 0 24px 0" }}>
              <div
                onKeyDown={(e) => {
                  if (e.key == "Enter") handleSubmit();
                }}>
                <InputCode
                  name="otp"
                  value={otp}
                  onChange={(e) => {
                    otpChangeHandler(e);
                  }}
                  onBlur={otpBlurHandler}
                  stateText="invalid otp"
                  state={otpError ? "error" : ""}
                  codeLength={6}
                />
              </div>

              {/* <InputCode codeLength={6} /> */}
            </Container>

            <Container horizontalAlign="end" fullWidth>
              <Button
                type="button"
                kind="tertiary"
                label="Resend OTP"
                loading={resendOTPLoading}
                onClick={resendOTPHandler}
              />
            </Container>

            <Container
              direction="row"
              fullWidth
              style={{ justifyContent: "flex-end" }}>
              {/* <Text appearance="body-s-link">Resend OTP</Text> */}
            </Container>
            <Container style={{ marginTop: "213px" }} fullWidth>
              <Button
                onClick={handleSubmit}
                fullWidth
                disabled={isValidForm}
                size="large"
                kind={verifyOtpLoading ? "secondary" : "primary"}>
                {verifyOtpLoading ? (
                  <Spinner kind="vibrant" label="Loading..." size="small" />
                ) : (
                  "Verify"
                )}
              </Button>
            </Container>
          </Container>
        )}
        {step == 1 && (
          <Container
            direction="column"
            fullWidth
            style={{ justifyContent: "" }}>
            <Container direction="column" gap={16} fullWidth>
              <Text appearance="heading-xs">Select account</Text>
              <Container direction="column" gap={0} className="">
                <Text appearance="body-s">
                  This number is linked with multiple Jio accounts.
                </Text>
              </Container>
            </Container>
            <div className={`${classes["access-input-container"]}`}>
              {userAccounts.map((userAccount, i) => (
                <div
                  className={`${classes["access-input-card"]} ${userId === userAccount.userId ? classes["active"] : classes["unactive"]}`}
                  onClick={() => {
                    setUserId(userAccount.userId);
                  }}>
                  <div className={`${classes["icon"]}`}>
                    <Icon
                      ic={
                        userAccount.productType === "Mobile"
                          ? "IcSim"
                          : "IcUser"
                      }
                      kind="background"
                      size="large"
                    />
                  </div>
                  <div className={`${classes["input-card-info"]}`}>
                    <p className={`${classes["input-card-dec"]}`}>
                      {userAccount.productType}
                    </p>
                    <p className={`${classes["input-card-title"]}`}>
                      {userAccount.phoneNumber}
                    </p>
                    <p className={`${classes["input-card-dec"]}`}>
                      {bytesToGB(userAccount.allocatedSpace)}GB entitlement
                    </p>
                  </div>
                </div>
              ))}
            </div>
            <Container
              direction="row"
              fullWidth
              style={{ justifyContent: "flex-end" }}>
              {/* <Text appearance="body-s-link">Resend OTP</Text> */}
            </Container>
            <Container style={{ marginTop: "213px" }} fullWidth>
              <Button
                onClick={() => handleUserIdLogin(userId, requestId)}
                fullWidth
                disabled={userId === null}
                size="large"
                kind={userIdLoginLoading ? "secondary" : "primary"}>
                {userIdLoginLoading ? (
                  <Spinner kind="vibrant" label="Loading..." size="small" />
                ) : (
                  "Continue"
                )}
              </Button>
            </Container>
          </Container>
        )}
      </div>
    </CustomCard>
  );
}
